import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { graphql, Link } from 'gatsby'
import Layout from '../components/Layout'
import Img from 'gatsby-image'
import Header from '../components/Header'
import arrow from '../img/arrow-left-solid.svg'

export const BlogPostTemplate = ({
    content,
    categories,
    tags,
    title,
    date,
    author,
}) => {
    return (
    <>
    <Header><Link to="/" className="header-text"> &#8617; Vijesti</Link></Header>
        <section className="section">
      <div className="container" style={{ border: 'none' }}><div
              className="content"
              style={{ border: 'none' }}
              >
            <p>
              <span className="post-header has-text-primary">{title}</span>
                  <br />
                  <small className="post-header small-date">
                    {date}
                  </small>
            </p>
            <div dangerouslySetInnerHTML={{ __html: content }} className="post-content" />
            
          </div>
          </div>
    </section>
      </>
    )
}

BlogPostTemplate.propTypes = {
    content: PropTypes.node.isRequired,
    title: PropTypes.string,
}

const BlogPost = ({ data }) => {
    const { wordpressPost: post } = data

    return (
        <Layout>
      <Helmet title={`${post.title} | Blog`} />
      <BlogPostTemplate
        content={post.content}
        categories={post.categories}
        tags={post.tags}
        title={post.title}
        date={post.date}
        author={post.author}
      />
    </Layout>
    )
}

BlogPost.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.object,
    }),
}

export default BlogPost

export const pageQuery = graphql `
  fragment PostFields on wordpress__POST {
    id
    slug
    content
    date(formatString: "DD.MM.YYYY")
    title
  }
  query BlogPostByID($id: String!) {
    wordpressPost(id: { eq: $id }) {
      id
      title
      slug
      content
      date(formatString: "DD.MM.YYYY")
      categories {
        name
        slug
      }
      tags {
        name
        slug
      }
      author {
        name
        slug
      }
    }
  }
`